import {
    Select as ChakraSelect,
    FormControl, FormLabel, Input, NumberInput, NumberInputField,
    Switch, Text, Textarea
} from "@chakra-ui/react";

export default function RequisitionFieldRenderer({ field, value, onChange }) {
    const common = (
        <>
            <FormLabel>
                {field.label}
                {field.required ? <Text as="span" color="red.500"> *</Text> : null}
            </FormLabel>
            {field.helpText && (
                <Text fontSize="xs" color="gray.500" mb={1}>{field.helpText}</Text>
            )}
        </>
    );

    switch (field.type) {
        case "text":
            return (
                <FormControl mb={3}>
                    {common}
                    <Input
                        placeholder={field.placeholder || ""}
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </FormControl>
            );

        case "number":
            return (
                <FormControl mb={3}>
                    {common}
                    <NumberInput
                        min={field.min}
                        max={field.max}
                        value={value || ""}
                        onChange={(_, v) => onChange(v)}
                    >
                        <NumberInputField placeholder={field.placeholder || ""} />
                    </NumberInput>
                </FormControl>
            );

        case "textarea":
            return (
                <FormControl mb={3}>
                    {common}
                    <Textarea
                        rows={3}
                        placeholder={field.placeholder || ""}
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </FormControl>
            );

        case "checkbox":
            return (
                <FormControl mb={3}>
                    {common}
                    <Switch
                        isChecked={!!value}
                        onChange={(e) => onChange(e.target.checked)}
                    />
                </FormControl>
            );

        case "datetime":
            return (
                <FormControl mb={3}>
                    {common}
                    <Input
                        type="datetime-local"
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </FormControl>
            );

        case "select":
            return (
                <FormControl mb={3}>
                    {common}
                    <ChakraSelect
                        placeholder="Select..."
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                    >
                        {(field.options || []).map((o) => (
                            <option key={o} value={o}>{o}</option>
                        ))}
                    </ChakraSelect>
                </FormControl>
            );

        case "multiselect":
            return (
                <FormControl mb={3}>
                    {common}
                    <ChakraSelect
                        multiple
                        value={value || []}
                        onChange={(e) =>
                            onChange(Array.from(e.target.selectedOptions).map((o) => o.value))
                        }
                    >
                        {(field.options || []).map((o) => (
                            <option key={o} value={o}>{o}</option>
                        ))}
                    </ChakraSelect>
                </FormControl>
            );

        case "datalist":
            return (
                <FormControl mb={3}>
                    {common}
                    <Input
                        list={`dl-${field.key}`}
                        placeholder={field.placeholder || ""}
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                    />
                    <datalist id={`dl-${field.key}`}>
                        {(field.options || []).map((o) => (
                            <option key={o} value={o} />
                        ))}
                    </datalist>
                </FormControl>
            );

        case "file":
            return (
                <FormControl mb={3}>
                    {common}
                    <Input
                        type="file"
                        multiple={!!field.maxFiles && field.maxFiles > 1}
                        accept={(field.accept || []).join(",")}
                        onChange={(e) => onChange([...e.target.files])}
                    />
                </FormControl>
            );

        case "display":
            return (
                <FormControl mb={3}>
                    {common}
                    <Text fontSize="sm" color="gray.600">
                        {value || "(read-only)"}
                    </Text>
                </FormControl>
            );

        default:
            return (
                <FormControl mb={3}>
                    {common}
                    <Input
                        placeholder={field.placeholder || ""}
                        value={value || ""}
                        onChange={(e) => onChange(e.target.value)}
                    />
                </FormControl>
            );
    }
}
